import moment from "moment";
import { formatDate } from "@shared/utils/date";

export const formatDetailDate = (timestamp: number, now = moment()) =>
  formatDate(
    timestamp,
    true,
    true,
    true,
    moment.unix(timestamp).year() !== now.year()
  );
